export default __webpack_public_path__ + "static/media/01.aef1e3c4.jpg";